<template>
  <div class="page">
    <div class="activity">
      <div class="activity-top">
        <div class="activityTitle">{{ props.data.titleCn }}</div>
        <div class="activityEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="activity-bottom">
        <img class="show-img" :src="props.data.imgUrl" alt="" />
        <div class="section-list">
          <div class="list-item" v-for="(item, index) in props.data.list" :key="index" @click="clickItem(item)">
            <img :src="item.imgUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})
const clickItem = (item) => {
  window.open(item.linkUrl, '_blank')
}

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .activity {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 72px;
    .activity-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .activityTitle{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .activityEn{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 12px;
      }
    }
    .activity-bottom{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
      .show-img{
        width: 100%;
        margin-top: 40px;
        margin-bottom: 12px;
      }
      .section-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .list-item{
          width: 85%;
          height: 120px;
          display: flex;
          justify-content: center;
          margin-top: 12px;
          border-radius: 6px;
          img{
            width: 100%;
            height: auto;
            border-radius: 6px;
          }
        }
      }
    }
  }
}
</style>
